(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baaklon-homepage"] && !Shopify.designMode) return;
  try {
    
function setupBaaklonHome(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const cards=[...root.querySelectorAll('[data-collection-card]')],grid=root.querySelector('.baaklon-home__grid'),search=root.querySelector('[data-collection-search]'),sort=root.querySelector('[data-collection-sort]'),filter=root.querySelector('[data-saved-filter]');
  let saved=[];
  try{const value=JSON.parse(localStorage.getItem('baaklon_saved_collections')||'[]');if(Array.isArray(value))saved=value.filter(v=>typeof v==='string')}catch{}
  let savedOnly=false;
  function refresh(){
    cards.forEach(card=>{
      const isSaved=saved.includes(card.dataset.handle),button=card.querySelector('[data-save-idea]');
      button.setAttribute('aria-pressed',String(isSaved));button.textContent=isSaved?root.dataset.savedLabel:root.dataset.saveLabel;
      card.hidden=(!card.dataset.title.toLowerCase().includes(search.value.trim().toLowerCase()))||(savedOnly&&!isSaved);
    });
    root.querySelector('[data-saved-count]').textContent=String(saved.length);
    root.querySelector('[data-empty-results]').hidden=cards.some(c=>!c.hidden);
  }
  cards.forEach(card=>card.querySelector('[data-save-idea]').addEventListener('click',()=>{
    const key=card.dataset.handle;saved=saved.includes(key)?saved.filter(v=>v!==key):[...saved,key];
    try{localStorage.setItem('baaklon_saved_collections',JSON.stringify(saved))}catch{}
    refresh();
  }));
  filter.addEventListener('click',()=>{savedOnly=!savedOnly;filter.setAttribute('aria-pressed',String(savedOnly));refresh()});
  search.addEventListener('input',refresh);
  sort.addEventListener('change',()=>{[...cards].sort((a,b)=>sort.value==='original'?Number(a.dataset.position)-Number(b.dataset.position):(sort.value==='az'?1:-1)*a.dataset.title.localeCompare(b.dataset.title)).forEach(c=>grid.appendChild(c))});
  refresh();
}
document.querySelectorAll('[data-baaklon-home]').forEach(setupBaaklonHome);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-baaklon-home]').forEach(setupBaaklonHome));

  } catch(e) { console.error(e); }
})();
})();
